/**
 * Product Image Hover Fix
 * Forces second product image to show on hover
 * Also loads deferred images on first hover
 */

(function() {
  'use strict';

  function loadDeferredImage(deferredImage) {
    // Check if it's a deferred-image custom element with a template
    const template = deferredImage.querySelector('template');
    if (template && template.content) {
      // Clone the template content and append it to the deferred-image
      const content = template.content.cloneNode(true);
      deferredImage.appendChild(content);
      // Remove the template to avoid re-loading
      template.remove();
      return true;
    }
    return false;
  }

  function initProductHover() {
    // Find all product items with double images
    const productItems = document.querySelectorAll('.product-item__image.double__image');

    if (!productItems.length) {
      // console.log('No double image products found');
      return;
    }

    // console.log(`Found ${productItems.length} products with double images`);

    productItems.forEach((productItem, index) => {
      // Find the second image element (might be deferred-image or direct element)
      let secondImage = productItem.querySelector('.product-item__bg__under');

      if (!secondImage) {
        // console.log(`Product ${index}: No second image found`);
        return;
      }

      // console.log(`Product ${index}: Setting up hover`);

      let imageLoaded = false;

      // Setup hover on the product item
      productItem.addEventListener('mouseenter', function() {
        // Load deferred image on first hover
        if (!imageLoaded && secondImage.tagName === 'DEFERRED-IMAGE') {
          imageLoaded = loadDeferredImage(secondImage);
          // console.log(`Product ${index}: Loaded deferred image`);
        }

        // Force show second image
        secondImage.style.position = 'absolute';
        secondImage.style.top = '0';
        secondImage.style.left = '0';
        secondImage.style.width = '100%';
        secondImage.style.height = '100%';
        secondImage.style.opacity = '1';
        secondImage.style.visibility = 'visible';
        secondImage.style.zIndex = '3';
        secondImage.style.display = 'block';
      });

      productItem.addEventListener('mouseleave', function() {
        // Force hide second image
        secondImage.style.opacity = '0';
        secondImage.style.visibility = 'hidden';
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductHover);
  } else {
    initProductHover();
  }

  // Re-run when AJAX content loads (for dynamic content)
  document.addEventListener('shopify:section:load', initProductHover);
})();
